import React from "react"

import Foods from "pages/foods"
import Settings from "pages/settings"
import ShiftCashierHistory from "pages/shift-cashier-history"
import SubscriptionPlans from "pages/subscription-plans"
import StockTransferRequests from "pages/stock-transfer-requests"
import RepositoryManagement from "pages/repository-management"
import PlaceOrder from "pages/place-order"
import PrinterViewer from "pages/printer-viewer"
import FailedPrinters from "pages/failed-printers"
import KitchenTables from "pages/kitchen-tables"
import Printer from "pages/printer"
import Checkout from "pages/checkout"
import Inventory from "pages/Inventory"
import CashManagment from "pages/cash-managment"
import Orders from "pages/orders"
import TableDecoration from "pages/table-decoration"
import RepositoryReport from "pages/repository-report"

const privateRoutes = [
  {
    path: "/foods",
    component: <Foods />
  },
  {
    path: "/settings",
    component: <Settings />
  },

  {
    path: "/shift-cashier-history",
    component: <ShiftCashierHistory />
  },

  {
    path: "/orders",
    component: <Orders />
  },
  {
    path: "/subscription-plans",
    component: <SubscriptionPlans />
  },
  {
    path: "/cash-managment",
    component: <CashManagment />
  },
  {
    path: "/table-decoration",
    component: <TableDecoration />
  },
  {
    path: "/inventory",
    component: <Inventory />
  },
  {
    path: "/checkout",
    component: <Checkout />
  },
  {
    path: "/printer",
    component: <Printer />
  },
  {
    path: "/kitchen-tables",
    component: <KitchenTables />
  },
  {
    path: "/failed-printers",
    component: <FailedPrinters />
  },
  {
    path: "/printer-viewer",
    component: <PrinterViewer />
  },
  {
    path: "/table-decoration",
    component: <TableDecoration />
  },
  {
    path: "/place-order",
    component: <PlaceOrder />
  },
  {
    path: "/repository-management",
    component: <RepositoryManagement />
  },
  {
    path: "/repository-report",
    component: <RepositoryReport />
  },
  {
    path: "/stock-transfer-requests",
    component: <StockTransferRequests />
  }
]

export default privateRoutes